<div class="details-view-container" *ngIf="professional">
  <mat-card appearance="outlined">
    <mat-card-content class="card-content">
      <mat-tab-group class="details-tab-group">
        <mat-tab label="Details">
          <div class="search-disciplines">
            <button
              mat-raised-button
              (click)="navigateToDisciplines(professional)"
              matTooltip="Search for disciplines"
              class="search-disciplines-button"
            >
              <mat-icon>search</mat-icon>
              Search for disciplines
            </button>
          </div>

          <div class="info-group">
            <div class="inline mt-10">
              <h4 *ngIf="professional?.status">
                <mat-icon class="mat-icon-small">verified_user</mat-icon>
                <strong>Status: {{ professional.status }}</strong>
              </h4>
            </div>

            <div *ngIf="professional?.preferredName">
              <mat-icon class="mat-icon-small">person</mat-icon>
              <strong>Preferred name: </strong>
              {{ professional.preferredName }}
            </div>

            <div *ngIf="professional?.previousNames">
              <mat-icon class="mat-icon-small">history</mat-icon>
              <strong>Previous name: </strong>
              {{ professional.previousNames }}
            </div>

            <div *ngIf="professional?.profession">
              <mat-icon class="mat-icon-small">badge</mat-icon>
              <strong>Profession: </strong>
              {{ professional.profession }}
            </div>

            <div class="phone-line" *ngIf="professional?.title">
              <mat-icon class="mat-icon-small">gavel</mat-icon>
              <strong>Title: </strong> 
              {{ professional.title }}
            </div>

            <div *ngIf="professional?.specialty">
              <mat-icon class="mat-icon-small">workspace_premium</mat-icon>
              <strong>Specialty: </strong>
              {{ professional.specialty }}
            </div>

            <div class="phone-line" *ngIf="professional?.phone">
              <mat-icon class="mat-icon-small">phone</mat-icon>
              <strong>Phone: </strong>
               {{ professional.phone }}
            </div>

            <div class="mail-line" *ngIf="professional?.email">
              <mat-icon class="mat-icon-small">email</mat-icon>
              <strong>Email: </strong> 
                {{ professional.email }}
            </div>

            <div class="mail-line" *ngIf="professional?.fax">
              <mat-icon class="mat-icon-small">fax</mat-icon>
              <strong>Fax: </strong>
                 {{ professional.fax }}
            </div>

            <div *ngIf="professional?.gender">
              <mat-icon class="mat-icon-small">wc</mat-icon>
              <strong>Gender: </strong>
              {{ professional.gender }}
            </div>

            <div *ngIf="professional?.registrationNumber">
              <mat-icon class="mat-icon-small">pin</mat-icon>
              <strong>Registration number: </strong>
              {{ professional.registrationNumber }}
            </div>

            <div *ngIf="professional?.memberSince">
              <mat-icon class="mat-icon-small">calendar_month</mat-icon>
              <strong>Member since: </strong>
              {{ professional.memberSince | date : dateFormat }}
            </div>

            <div *ngIf="professional?.registrationDate">
              <mat-icon class="mat-icon-small">event</mat-icon>
              <strong>Registration date: </strong>
              {{ professional.registrationDate | date : dateFormat }}
            </div>

            <div
              *ngIf="
                formatAuthorizations(
                  professional.authorizations
                ) as authorizations
              "
            >
              <div *ngIf="authorizations.length > 0" class="vertical-list">
                <mat-icon class="mat-icon-small">verified</mat-icon>
                <strong>Authorizations: </strong>
                <ul *ngFor="let authorization of authorizations">
                  <li *ngIf="authorization && authorization != 'null'">
                    <p>
                      {{ authorization | formatAuthorizationDates }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div *ngIf="professional?.address">
              <mat-icon class="mat-icon-small">home</mat-icon>
              <strong>Address: </strong>
              {{ professional.address }}
            </div>

            <div *ngIf="professional?.licenceType">
              <mat-icon class="mat-icon-small">description</mat-icon>
              <strong>Licence type: </strong>
              {{ professional.licenceType }}
            </div>

            <div *ngIf="professional?.licenceExpiryDate">
              <mat-icon class="mat-icon-small">calendar_today</mat-icon>
              <strong>Licence expiry:</strong>
              {{ professional.licenceExpiryDate | date : dateFormat }}
            </div>

            <div *ngIf="professional?.licenceConditions">
              <mat-icon class="mat-icon-small">gavel</mat-icon>
              <strong>Licence conditions:</strong>
              {{ professional.licenceConditions }}
            </div>
          </div>

          <div *ngIf="professional?.notes">
            <mat-icon class="mat-icon-small">note</mat-icon>
            <strong>Notes:</strong> {{ professional.notes }}
          </div>

          <div class="mt-10" *ngIf="hasValidWorkplaces">
            <mat-divider class="section-divider"></mat-divider>

            <p class="title-section">
              <mat-icon class="mat-icon-small">work</mat-icon>
              <strong>Workplace:</strong>
            </p>

            <ul class="horizontal-professional-list">
              <ng-container *ngFor="let workplace of professional?.workplaces">
                <li *ngIf="workplace?.provider?.name" class="staff-card">
                  <div class="inline">
                    <button
                      class="search-entity-button"
                      mat-raised-button
                      (click)="navigateToProvider(workplace?.provider)"
                      matTooltip="Search for provider"
                    >
                      {{ workplace.provider?.name }}
                    </button>

                    <a
                      *ngIf="formatUrl(workplace?.provider?.url) as providerUrl"
                      [href]="providerUrl"
                      [matTooltip]="providerUrl"
                      target="_blank"
                      class="link-with-icon"
                      rel="noopener"
                      aria-label="Opens in a new tab"
                    >
                      <mat-icon class="mat-icon-small">open_in_new</mat-icon>
                    </a>
                  </div>

                  <div class="mt-10">
                    <p
                      *ngIf="getAddress(workplace?.provider) as providerAddress"
                    >
                      <strong>Address: </strong> {{ providerAddress }}
                    </p>

                    <p *ngIf="workplace?.position">
                      <strong>Position: </strong> {{ workplace.position }}
                    </p>

                    <p *ngIf="workplace?.type">
                      <strong>Type: </strong> {{ workplace.type }}
                    </p>

                    <p *ngIf="workplace?.startDate">
                      <strong>Start date: </strong>
                      {{ workplace.startDate | date : dateFormat }}
                    </p>
                  </div>
                </li>
              </ng-container>
            </ul>
          </div>

          <div *ngIf="professional.directorAts?.length > 0" class="mt-10">
            <p class="title-section"><strong>Other workplaces:</strong></p>
            <ul class="horizontal-professional-list">
              <li
                *ngFor="let workplace of professional?.directorAts"
                class="staff-card"
              >
                <div class="inline">
                  <button
                    class="search-entity-button"
                    mat-raised-button
                    (click)="navigateToProvider(workplace?.provider)"
                    matTooltip="Search for provider"
                  >
                    {{ workplace.provider?.name }}
                  </button>
                  <a
                    *ngIf="formatUrl(workplace?.provider?.url) as providerUrl"
                    [href]="providerUrl"
                    [matTooltip]="providerUrl"
                    target="_blank"
                    class="link-with-icon"
                    rel="noopener"
                    aria-label="Opens in a new tab"
                  >
                    <mat-icon class="mat-icon-small">open_in_new</mat-icon>
                  </a>
                </div>
                <div class="mt-10">
                  <p *ngIf="getAddress(workplace?.provider) as providerAddress">
                    <strong>Address: </strong>
                    {{ providerAddress }}
                  </p>
                  <p *ngIf="workplace?.position">
                    <strong>Position: </strong>
                    {{ workplace.position }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="last-updated" *ngIf="professional?.lastUpdatedDate">
            <p>
              Last updated:
              {{ professional.lastUpdatedDate | date : dateFormat }}
            </p>
          </div>
        </mat-tab>

        <mat-tab *ngIf="professional.events?.[0]?.documents?.length > 0">
          <ng-template mat-tab-label>
            <mat-icon class="concern-warning">warning</mat-icon>
            {{ concernTypes }}
          </ng-template>

          <div
            *ngFor="let document of professional.events[0].documents"
            class="document-wrapper"
          >
            <app-safe-html-viewer
              [matTooltip]="
                document?.url ? 'Download file: ' + document?.url : ''
              "
              [rawHtml]="getDocumentHtml(document)"
            ></app-safe-html-viewer>
          </div>

          <div class="last-updated" *ngIf="professional?.lastUpdatedDate">
            <p>
              Last updated:
              {{ professional.lastUpdatedDate | date : dateFormat }}
            </p>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>
